import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import Loader from "../componants/Loader";
import axios from "axios";

const CompanyDetails = () => {
  const [username, setUsername] = useState("");
  const [company, setCompany] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [productError, setProductError] = useState(false);
  const [allData, setAllData] = useState("");
  const [flag, setFlag] = useState(false);
  const [ApiResponse, setApiResponse] = useState("");
  const [lodar, setLodar] = useState(false);


  const handleLogin = () => {
    let isValid = true;
    if (!username) {
      setUsernameError(true);
      isValid = false;
    }

    if (!company) {
      setProductError(true);
      isValid = false;
    }
    if (isValid) {
      setAllData({ username, company });
    }
  };
console.log(ApiResponse);
  useEffect(() => {
    if (allData) {
      setLodar(true);
      axios.post("/addcustomerdetails", allData).then((response) => {
        setApiResponse(response);
        setLodar(false);
        setFlag(true);
        setUsername("")
        setCompany("")
      });
    }
  }, [allData]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFlag(false);
  };

    if (lodar) {
      return <Loader />;
    }

  return (
    <>
      <Typography variant="h5" sx={{ my: 4, mx: 5 }}>
        Add Company Details
      </Typography>
      <Stack
        justifyContent={"center"}
        width={"100%"}
        spacing={4}
        alignItems={"center"}
      >
        <TextField
          sx={{ width: "70%" }}
          autoFocus
          margin="dense"
          placeholder="Ex- GBK@1234"
          id="username"
          label="Username"
          type="text"
          fullWidth
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
            setUsernameError(false);
          }}
          error={usernameError}
          helperText={usernameError && "Username is required"}
        />

        <TextField
          sx={{ width: "70%" }}
          margin="dense"
          placeholder="Ex- Meon Technology Pvt Ltd"
          id="company"
          label="company"
          type="text"
          fullWidth
          value={company}
          onChange={(e) => {
            setCompany(e.target.value);
            setProductError(false);
          }}
          error={productError}
          helperText={productError && "Company Name is required"}
        />

        <Button
          variant="contained"
          sx={{ width: "70%" }}
          onClick={handleLogin}
          color="primary"
        >
          Submit
        </Button>
      </Stack>

      <Snackbar
        open={flag}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{
          background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
          color: "white",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={"success"}
          sx={{ width: "100%" }}
        >
          Company Name Updated Successfully !
        </Alert>
      </Snackbar>
    </>
  );
};

export default CompanyDetails;
